/* eslint-disable*/
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SingleNewHireException,
  SingleNewHireExceptionHeader,
  SingleNewHireExceptionMocked,
  SingleNewHireExceptionTitle,
} from './styles';
import { AlertAdapter, DatePicker, RegularButton } from 'pg-ui-library';
import {
  NewHireExceptionModalBody,
  NewHireExceptionModalForm,
  NewHireExceptionModalLabel,
  NewHireExceptionModalFormNumber,
  NewHireExceptionModalNumber,
  NewHireExceptionModalFooter,
} from 'src/components/new-hire-exception-modal/styles';
import { useMutation, useQuery } from '@tanstack/react-query';
import NewHireExceptionService from 'src/services/new-hire-exception.service';
import { INewHireException, INewHireRange } from 'src/interfaces';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

const NewHireExceptionIndividual: React.FC = () => {
  const [newHireDate, setNewHireDate] = useState<INewHireRange>();
  const { selectedEmployee } = useTypedSelector(state => state.employees.data);
  const { refetch: refetchHistoric } = useQuery(['employee/new-hire-historic'], () =>
    NewHireExceptionService.getHirtoric(selectedEmployee.employee?.id as unknown as '')
  );
  const { t } = useTranslation();
  const today = new Date();
  const minDate = new Date();
  const maxDate = new Date();
  minDate.setDate(minDate.getDate() - 1);
  maxDate.setMonth(minDate.getMonth() + 3);
  const { isFetching, data: newHireRange } = useQuery(['newHireException/range'], async () => {
    const result = await NewHireExceptionService.getNewHireRange(selectedEmployee.employee?.id as unknown as '');
    return result;
  });

  const newHireExceptionSchema = yup.object({
    advance: yup.date().min(minDate).max(maxDate).nullable(),
    extend: yup.number().min(0).max(60).nullable(),
  });

  const mutationCreate = useMutation(
    (variables: INewHireException) =>
      NewHireExceptionService.create({
        employeeId: [selectedEmployee.employee?.id as unknown as ''],
        advance: variables.advance,
        extend: variables.extend,
      }),
    {
      onSuccess: () => {
        AlertAdapter('New Hire Exception created successfully!', 'success');
        refetchHistoric();
      },
      onError: () => {
        AlertAdapter('Failed to create New Hire Exception', 'error');
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      advance: undefined,
      extend: 0,
    },
    validationSchema: newHireExceptionSchema,
    onSubmit: async (values: INewHireException) => {
      mutationCreate.mutate(values);
    },
  });

  useEffect(() => {
    if (newHireRange) {
      setNewHireDate(newHireRange.data);
    }
  }, [newHireRange]);

  return (
    <SingleNewHireException>
      <form onSubmit={formik.handleSubmit}>
        <SingleNewHireExceptionHeader>
          <SingleNewHireExceptionTitle>{t('newhireException.modal.title')}</SingleNewHireExceptionTitle>
        </SingleNewHireExceptionHeader>
        <NewHireExceptionModalBody style={{ flexDirection: 'row', justifyContent: 'left' }}>
          <NewHireExceptionModalForm style={{ marginRight: '2%' }}>
            <NewHireExceptionModalLabel>{t('newhireException.modal.start')}</NewHireExceptionModalLabel>
            <div style={{ marginRight: '5%', marginTop: '5%' }}>
              <SingleNewHireExceptionMocked
                disabled
                value={newHireDate?.startNewHire || isFetching ? newHireDate?.startNewHire : ''}
              />
            </div>
          </NewHireExceptionModalForm>
          <NewHireExceptionModalForm style={{ marginRight: '1.9%' }}>
            <NewHireExceptionModalLabel>{t('newhireException.modal.extend')}</NewHireExceptionModalLabel>
            <div style={{ marginRight: '5%', marginTop: '-4.2%' }}>
              <DatePicker
                id="advance"
                name="advance"
                selected={formik.values.advance}
                onChange={date => formik.setFieldValue('advance', date)}
                label=""
                placeholderText="MM/DD/YY"
                minDate={today}
                maxDate={maxDate}
              />
            </div>
          </NewHireExceptionModalForm>
          <NewHireExceptionModalForm style={{ marginRight: '0.3%' }}>
            <NewHireExceptionModalLabel>{t('newhireException.modal.advance')}</NewHireExceptionModalLabel>
            <NewHireExceptionModalFormNumber style={{ color: 'black' }}>
              <NewHireExceptionModalNumber
                id="extend"
                name="extend"
                onChange={formik.handleChange}
                min={0}
                placeholder="Type Here..."
                type="number"
              />
              <NewHireExceptionModalLabel>{t('newhireException.modal.advanceDays')}</NewHireExceptionModalLabel>
            </NewHireExceptionModalFormNumber>
          </NewHireExceptionModalForm>
          <NewHireExceptionModalForm>
            <NewHireExceptionModalLabel style={{ marginLeft: '6%' }}>
              {t('newhireException.modal.end')}
            </NewHireExceptionModalLabel>
            <div style={{ marginLeft: '5%', marginTop: '5%' }}>
              <SingleNewHireExceptionMocked
                disabled
                value={newHireDate?.endNewHire || isFetching ? newHireDate?.endNewHire : ''}
              />
            </div>
          </NewHireExceptionModalForm>
          <RegularButton
            disabled={!formik.isValid || mutationCreate.isLoading}
            style={{ marginTop: '2.6%', width: '100px', marginLeft: '45%' }}
            type="submit"
          >
            {t('global.form.save')}
          </RegularButton>
        </NewHireExceptionModalBody>
      </form>
    </SingleNewHireException>
  );
};
export default NewHireExceptionIndividual;
